import React, { useState } from "react";
import axios from "axios";

const emptyTheme3 = {
  defaultDepartmentImage: "",
  defaultTypeImage: "",
  defaultTypeHeroImage: "",
  defaultTypeHeroTitle: "",
  defaultTypeHeroSubtitle: "",
  departments: {},
  types: {},
};

const PostBrand = () => {
  const [formData, setFormData] = useState({
    brandName: "",
    headerImage: null,
    logo: null,
    theme: "theme1",
  });

  const [theme3Config, setTheme3Config] = useState(emptyTheme3);
  const [departmentKey, setDepartmentKey] = useState("");
  const [typeKey, setTypeKey] = useState("");
  const [status, setStatus] = useState("");

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    }
  };

  const updateTheme3Root = (name, value) => {
    setTheme3Config((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const addDepartment = () => {
    if (!departmentKey.trim()) return;

    const key = departmentKey.trim();

    setTheme3Config((prev) => ({
      ...prev,
      departments: {
        ...prev.departments,
        [key]: {
        image: "",
        title: "",
        subtitle: "",

        heroImage: "",
        heroTitle: "",
        heroSubtitle: "",
      },
      },
    }));

    setDepartmentKey("");
  };

  const updateDepartment = (key, field, value) => {
    setTheme3Config((prev) => ({
      ...prev,
      departments: {
        ...prev.departments,
        [key]: {
          ...prev.departments[key],
          [field]: value,
        },
      },
    }));
  };

  const removeDepartment = (key) => {
    setTheme3Config((prev) => {
      const next = { ...prev.departments };
      delete next[key];

      return {
        ...prev,
        departments: next,
      };
    });
  };

  const addType = () => {
  if (!typeKey.trim()) return;

  const key = typeKey.trim();

  setTheme3Config((prev) => ({
    ...prev,
    types: {
      ...prev.types,
      [key]: {
        image: "",
        title: "",
        subtitle: "",
        heroImage: "",
        heroTitle: "",
        heroSubtitle: "",
      },
    },
  }));

  setTypeKey("");
};

  const updateType = (key, field, value) => {
    setTheme3Config((prev) => ({
      ...prev,
      types: {
        ...prev.types,
        [key]: {
          ...prev.types[key],
          [field]: value,
        },
      },
    }));
  };

  const removeType = (key) => {
    setTheme3Config((prev) => {
      const next = { ...prev.types };
      delete next[key];

      return {
        ...prev,
        types: next,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");

    if (!formData.brandName || !formData.headerImage || !formData.logo || !formData.theme) {
      setStatus("⚠️ Please fill in all fields.");
      return;
    }

    try {
      const payload = new FormData();

      payload.append("brandName", formData.brandName);
      payload.append("theme", formData.theme);
      payload.append("headerImage", formData.headerImage);
      payload.append("logo", formData.logo);

      if (formData.theme === "theme3") {
        payload.append("themeConfig", JSON.stringify(theme3Config));
      }

      const response = await axios.post(
        "https://api.malidag.com/api/brands/add",
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        setStatus("✅ Brand added successfully!");

        setFormData({
          brandName: "",
          headerImage: null,
          logo: null,
          theme: "theme1",
        });

        setTheme3Config(emptyTheme3);
      } else {
        setStatus("❌ Failed to add brand.");
      }
    } catch (error) {
      console.error("Error posting brand:", error);
      setStatus(error.response?.data?.error || "❌ Error occurred while posting brand.");
    }
  };

  return (
    <div style={{ maxWidth: "850px", margin: "2rem auto", padding: "1rem" }}>
      <h2>Add New Brand</h2>

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <label>Brand Name:</label>
        <input
          type="text"
          name="brandName"
          value={formData.brandName}
          onChange={handleTextChange}
          required
        />

        <br />

        <label>Header Image:</label>
        <input
          type="file"
          name="headerImage"
          accept="image/*"
          onChange={handleFileChange}
          required
        />

        <br />

        <label>Logo:</label>
        <input
          type="file"
          name="logo"
          accept="image/*"
          onChange={handleFileChange}
          required
        />

        <br />

        <label>Theme:</label>
        <select
          name="theme"
          value={formData.theme}
          onChange={handleTextChange}
          required
        >
          <option value="theme1">theme1</option>
          <option value="theme2">theme2</option>
          <option value="theme3">theme3</option>
        </select>

        {formData.theme === "theme3" && (
          <div style={{ marginTop: "2rem", borderTop: "1px solid #ddd", paddingTop: "1rem" }}>
            <h3>Theme3 Setup</h3>

            <label>Default Department Image URL:</label>
            <input
              type="text"
              value={theme3Config.defaultDepartmentImage}
              onChange={(e) => updateTheme3Root("defaultDepartmentImage", e.target.value)}
              placeholder="https://cdn.malidag.com/..."
            />

            <br />

            <label>Default Type Image URL:</label>
            <input
              type="text"
              value={theme3Config.defaultTypeImage}
              onChange={(e) => updateTheme3Root("defaultTypeImage", e.target.value)}
              placeholder="https://cdn.malidag.com/..."
            />

            <br />

            <label>Default Type Hero Image URL:</label>
            <input
              type="text"
              value={theme3Config.defaultTypeHeroImage}
              onChange={(e) => updateTheme3Root("defaultTypeHeroImage", e.target.value)}
              placeholder="https://cdn.malidag.com/..."
            />

            <br />

          <label>Default Type Hero Title:</label>
          <input
            type="text"
            value={theme3Config.defaultTypeHeroTitle || ""}
            onChange={(e) =>
              updateTheme3Root("defaultTypeHeroTitle", e.target.value)
            }
            placeholder="Default hero title"
          />

          <br />

          <label>Default Type Hero Subtitle:</label>
          <input
            type="text"
            value={theme3Config.defaultTypeHeroSubtitle || ""}
            onChange={(e) =>
              updateTheme3Root("defaultTypeHeroSubtitle", e.target.value)
            }
            placeholder="Default hero subtitle"
          />

            <hr />

            <h3>Departments</h3>

            <input
              type="text"
              value={departmentKey}
              onChange={(e) => setDepartmentKey(e.target.value)}
              placeholder="department key, example: mixers"
            />

            <button type="button" onClick={addDepartment}>
              Add Department
            </button>

            {Object.entries(theme3Config.departments).map(([key, dept]) => (
              <div key={key} style={{ marginTop: "1rem", padding: "1rem", border: "1px solid #ddd" }}>
                <strong>{key}</strong>

                <input
                  type="text"
                  value={dept.image}
                  onChange={(e) => updateDepartment(key, "image", e.target.value)}
                  placeholder="Department image URL optional"
                />

                <input
                  type="text"
                  value={dept.title}
                  onChange={(e) => updateDepartment(key, "title", e.target.value)}
                  placeholder="Title optional"
                />

                <input
                  type="text"
                  value={dept.subtitle}
                  onChange={(e) => updateDepartment(key, "subtitle", e.target.value)}
                  placeholder="Subtitle optional"
                />

                <input
                  type="text"
                  value={dept.heroImage || ""}
                  onChange={(e) =>
                    updateDepartment(key, "heroImage", e.target.value)
                  }
                  placeholder="Department hero image URL optional"
                />

                <input
                  type="text"
                  value={dept.heroTitle || ""}
                  onChange={(e) =>
                    updateDepartment(key, "heroTitle", e.target.value)
                  }
                  placeholder="Department hero title optional"
                />

                <input
                  type="text"
                  value={dept.heroSubtitle || ""}
                  onChange={(e) =>
                    updateDepartment(key, "heroSubtitle", e.target.value)
                  }
                  placeholder="Department hero subtitle optional"
                />

                <button type="button" onClick={() => removeDepartment(key)}>
                  Remove
                </button>
              </div>
            ))}

            <hr />

            <h3>Types</h3>

            <input
              type="text"
              value={typeKey}
              onChange={(e) => setTypeKey(e.target.value)}
              placeholder="type key, example: hand-mixers"
            />

            <button type="button" onClick={addType}>
              Add Type
            </button>

            {Object.entries(theme3Config.types).map(([key, type]) => (
              <div key={key} style={{ marginTop: "1rem", padding: "1rem", border: "1px solid #ddd" }}>
                <strong>{key}</strong>

                <input
                  type="text"
                  value={type.image}
                  onChange={(e) => updateType(key, "image", e.target.value)}
                  placeholder="Type card image URL optional"
                />

                <input
                  type="text"
                  value={type.heroImage}
                  onChange={(e) => updateType(key, "heroImage", e.target.value)}
                  placeholder="Type hero image URL optional"
                />

                <input
                type="text"
                value={type.heroTitle || ""}
                onChange={(e) => updateType(key, "heroTitle", e.target.value)}
                placeholder="Type hero title optional"
              />

              <input
                type="text"
                value={type.heroSubtitle || ""}
                onChange={(e) => updateType(key, "heroSubtitle", e.target.value)}
                placeholder="Type hero subtitle optional"
              />

                <input
                  type="text"
                  value={type.title}
                  onChange={(e) => updateType(key, "title", e.target.value)}
                  placeholder="Title optional"
                />

                <input
                  type="text"
                  value={type.subtitle}
                  onChange={(e) => updateType(key, "subtitle", e.target.value)}
                  placeholder="Subtitle optional"
                />

                <button type="button" onClick={() => removeType(key)}>
                  Remove
                </button>
              </div>
            ))}
          </div>
        )}

        <br />

        <button type="submit" style={{ marginTop: "20px" }}>
          Submit
        </button>
      </form>

      {status && (
        <p style={{ marginTop: "1rem", color: status.startsWith("✅") ? "green" : "red" }}>
          {status}
        </p>
      )}
    </div>
  );
};

export default PostBrand;